import React, { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
import { Row, Col, Input, Space, Select } from 'antd';
// import {ToastContainer} from "react-toastify"
// import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import { notifycatch } from "../utils/toast";
import { TokenVerificationLoggedOut } from "../utils/tokenVerify";
import { jwtDecode } from "jwt-decode";
// import { Link } from "react-router-dom";
import constantData from "../constants/constantData.json";
import emailIcon from "../assets/images/login-and-signup/email.svg";
import passwordIcon from "../assets/images/login-and-signup/password.svg";
import userIcon from '../assets/images/login-and-signup/name.svg';
import organisationIcon from '../assets/images/login-and-signup/organisation.svg';
import websiteIcon from '../assets/images/login-and-signup/website.svg';
import loaderIcon from "../assets/images/login-and-signup/loader.gif";
import { Swiper, SwiperSlide } from "swiper/react";
import bannerImage from "../assets/logo/banner_main.svg"
import { Autoplay } from "swiper/modules";  // Import the Autoplay module
import 'swiper/css'; // Import base Swiper CSS
import blackLogo from "../assets/logo/helix_black_logo_with_xapads.svg"

const Login = (props) => {
  const [loading, setLoading] = useState(true);
  const [formState, setFormState] = useState(1);
  const buttonRef0 = useRef(null);
  const buttonRef1 = useRef(null);
  const buttonRef2 = useRef(null);

  const [ip, setIp] = useState(null);

  React.useEffect(() => {
    getIP()
  }, [])

  const getIP = async () => {
    try {
      const res = await axios.get("https://geolocation-db.com/json/");
      Cookies.set("IP", res.data.IPv4, { expires: 1 });
      setIp(res.data.IPv4)
    } catch (error) { }

  };

  const downloadFile = async () => {
    try {
      const response = await fetch('https://unified-supply-platform.s3.ap-south-1.amazonaws.com/mediaKit/Helix_by_Xapads-Media_Kit.pdf', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/octet-stream',
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Helix_by_Xapads-Media_Kit.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        // notifyfailure("Failed to download the file")
      }
    } catch (error) {
      // notifyfailure("Failed to download the file")
    }
  };


  const loginMoveRef = useRef(null)

  const scrollToItem = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };


  useEffect(() => {
    TokenVerificationLoggedOut();
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      setTimeout(() => { }, 1500);
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const handleEnterKeyPress1 = (event) => {
      if (event.key === "Enter" && buttonRef1 && buttonRef1?.current) {
        buttonRef1?.current.click();
      }
    };

    // Add keydown event listener to the document
    document.addEventListener("keydown", handleEnterKeyPress1);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress1);
    };
  }, []);

  useEffect(() => {
    const handleEnterKeyPress2 = (event) => {
      if (event.key === "Enter" && buttonRef2 && buttonRef2?.current) {
        buttonRef2?.current.click();
      }
    };
    document.addEventListener("keydown", handleEnterKeyPress2);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress2);
    };
  }, []);

  useEffect(() => {
    const handleEnterKeyPress0 = (event) => {
      if (event.key === "Enter" && buttonRef0 && buttonRef0?.current) {
        buttonRef0?.current.click();
      }
    };
    document.addEventListener("keydown", handleEnterKeyPress0);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress0);
    };
  }, []);


  //////////////////////////////////////////Register code ////////////////////////////////////////

  const [name, setName] = useState("");
  const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

  const [companyName, setCompanyName] = useState("");
  const [companyNameIsRequiredError, setCompanyNameIsRequiredError] =
    useState(false);

  const [emailRegister, setEmailRegister] = useState("");
  const [emailRegisterIsRequiredError, setEmailRegisterIsRequiredError] = useState(false);
  const [emailRegisterUrlError, setEmailRegisterUrlError] = useState(false);

  const [companyWebsite, setCompanyWebsite] = useState("");
  const [companyWebsiteIsRequiredError, setCompanyWebsiteIsRequiredError] =
    useState(false);
  const [companyWebsiteUrlError, setCompanyWebsiteUrlError] = useState(false);

  const [im, setIm] = useState("");
  const [imIsRequiredError, setImIsRequiredError] = useState(false);

  const [selectedIm, setSelectedIm] = useState("skype");

  const [buttonValue, setButtonValue] = useState(false);

  const validateWebsiteUrl = (websiteUrl) => {
    return String(websiteUrl)
      .toLowerCase()
      .match(/.+[.].+/);
  };


  function resetRegiterScreen() {
    setName("")
    setNameIsRequiredError(false)
    setCompanyName("")
    setCompanyNameIsRequiredError(false)
    setEmailRegister("")
    setEmailRegisterIsRequiredError(false)
    setEmailRegisterUrlError(false)
    setCompanyWebsite("")
    setCompanyWebsiteIsRequiredError(false)
    setCompanyWebsiteUrlError(false)
    setIm("")
    setImIsRequiredError(false)
    setSelectedIm("skype")
    setButtonValue(false)
  }

  function onChangeName(event) {
    setNameIsRequiredError(false);
    setName(event.target.value);
  }

  function onBlurName(event) {
    if (event.target.value.trim().length === 0) {
      setNameIsRequiredError(true);
    }
    setName(event.target.value.trim());
  }

  function onChangeCompanyName(event) {
    setCompanyNameIsRequiredError(false);
    setCompanyName(event.target.value);
  }

  function onBlurCompanyName(event) {
    if (event.target.value.trim().length === 0) {
      setCompanyNameIsRequiredError(true);
      setCompanyName("");
    }
    setCompanyName(event.target.value.trim());
  }

  function onChangeEmailRegister(event) {
    setEmailRegisterIsRequiredError(false);
    setEmailRegister(event.target.value);

    if (validateEmail(event.target.value) === null) {
      setEmailRegisterUrlError(true);
    } else {
      setEmailRegisterUrlError(false);
    }
  }

  function onBlurEmailRegister(event) {
    if (event.target.value.trim().length === 0) {
      setEmailRegisterUrlError(false);
      setEmailRegisterIsRequiredError(true);
    }
    else {
      if (validateEmail(event.target.value.trim()) === null) {
        setEmailRegisterUrlError(true);
      } else {
        setEmailRegisterUrlError(false);
      }
    }
    setEmailRegister(event.target.value.trim());
  }

  function onChangeIm(event) {
    setImIsRequiredError(false);
    setIm(event.target.value);
  }

  function onBlurIm(event) {
    if (event.target.value.trim().length === 0) {
      setImIsRequiredError(true);
    }
    setIm(event.target.value.trim())
  }

  function onChangeSelectedIm(event) {
    setSelectedIm(event);
  }

  function onChangeCompanyWebsite(event) {
    setCompanyWebsite(event.target.value);

    if (event.target.value.length === 0) {
      setCompanyWebsiteUrlError(false);
      setCompanyWebsiteIsRequiredError(true);
    } else {
      setCompanyWebsiteIsRequiredError(false);

      if (validateWebsiteUrl(event.target.value) === null) {
        setCompanyWebsiteUrlError(true);
      } else {
        setCompanyWebsiteUrlError(false);
      }
    }
  }

  function onBlurCompanyWebsite(event) {
    if (event.target.value.trim().length === 0) {
      setCompanyWebsiteUrlError(false);
      setCompanyWebsiteIsRequiredError(true);
    }
    else {
      if (validateWebsiteUrl(event.target.value.trim()) === null) {
        setCompanyWebsiteUrlError(true);
      } else {
        setCompanyWebsiteUrlError(false);
      }
    }
    setCompanyWebsite(event.target.value.trim());
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      name !== "" &&
      companyName !== "" &&
      emailRegister !== "" &&
      companyWebsite !== "" &&
      im !== ""
    ) {
      if (
        nameIsRequiredError === false &&
        companyNameIsRequiredError === false &&
        emailRegisterIsRequiredError === false &&
        emailRegisterUrlError === false &&
        companyWebsiteUrlError === false &&
        companyWebsiteIsRequiredError === false &&
        imIsRequiredError === false
      ) {
        let payload = {
          p_name: name,
          o_name: companyName,
          email: emailRegister,
          c_website: companyWebsite,
          im: { "label": selectedIm, "value": im }
        };


        setButtonValue(true);
        scrollToItem(loginMoveRef)

        axios
          .post(configData.SERVER_URL + "user/signup", payload)
          .then((response) => {

            notifysuccess(response.data.message);
            setFormState(1)
            resetRegiterScreen()

          })
          .catch((error) => {
            if (error?.response) {
              if (error?.response?.data?.message?.length !== 0) {
                notifyfailure(error.response.data.message)
              }
            } else {
              notifycatch()
            }
            setButtonValue(false);
          });
      }
    } else {
      if (name === "") {
        setNameIsRequiredError(true);
      }
      if (companyName === "") {
        setCompanyNameIsRequiredError(true);
      }
      if (emailRegister === "") {
        setEmailRegisterIsRequiredError(true);
      }
      if (companyWebsite === "") {
        setCompanyWebsiteIsRequiredError(true);
      }
      if (im === "") {
        setImIsRequiredError(true);
      }
    }
  };



  // /////////////////////////////////////Logincode ////////////////////////////////////////////////

  const [email, setEmail] = useState("");
  const [emailIsRequiredError, setEmailIsRequiredError] = useState(false);
  const [emailUrlError, setEmailUrlError] = useState(false);

  const [buttonValueEmail, setButtonValueEmail] = useState(false);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  function onChangeEmail(event) {
    setEmail(event.target.value.trim());

    if (event.target.value.trim().length === 0) {
      setEmailUrlError(false);
      setEmailIsRequiredError(true);
    } else {
      setEmailIsRequiredError(false);
      if (validateEmail(event.target.value.trim()) === null) {
        setEmailUrlError(true);
      } else {
        setEmailUrlError(false);
      }
    }
  }

  function onBlurEmail(event) {
    setEmail(email.trim());
    if (event.target.value.trim().length === 0) {
      setEmailUrlError(false);
      setEmailIsRequiredError(true);
    }
  }


  function resetLoginScreen() {
    setEmail("")
    setEmailIsRequiredError(false)
    setEmailUrlError(false)
    setButtonValueEmail(false)
    setOtp("")
    setOtpIsRequiredError(false)
    setOtpLengthError(false)
    setButtonValueOtp(false)
    setButtonValueResend(false)
    setCountdown(60)
  }

  const handleSubmitEmail = async (e) => {
    e.preventDefault();

    if (email !== "") {
      if (emailIsRequiredError === false && emailUrlError === false) {
        let payload = {
          email: email,
        };

        setButtonValueEmail(true);

        axios
          .post(configData.SERVER_URL + "user/sendOtp", payload)
          .then((response) => {
            notifysuccess(response.data.message);
            setButtonValueEmail(false);
            setButtonValueResend(true)
            handleTimeout()
            setFormState(2);
          })
          .catch((error) => {
            if (error?.response) {
              if (error?.response?.data?.message?.length !== 0) {
                notifyfailure(error.response.data.message);
              }
            } else {
              notifycatch();
            }
            setButtonValueEmail(false);
          });
      }
    } else {
      if (email === "") {
        setEmailIsRequiredError(true);
      }
    }
  };


  // /////////////////////////////////////Otp code ////////////////////////////////////////////////

  const [otp, setOtp] = useState("");
  const [otpIsRequiredError, setOtpIsRequiredError] = useState(false);
  const [otpLengthError, setOtpLengthError] = useState(false);
  const [buttonValueOtp, setButtonValueOtp] = useState(false);
  const [buttonValueResend, setButtonValueResend] = useState(false);

  const [countdown, setCountdown] = useState(60);

  const resendOtp = () => {
    setCountdown(60)
    setButtonValueResend(true)

    let payload = {
      email: email,
    };
    axios
      .post(configData.SERVER_URL + "user/sendOtp", payload)
      .then((response) => {
        notifysuccess(response.data.message);
        handleTimeout()

      })
      .catch((error) => {
        if (error.response.data.message?.length !== 0) {
          notifyfailure(error.response.data.message);

        } else {
          notifycatch();
        }

        // setCountdown(0)
        setButtonValueResend(false)
      });

  }


  const handleTimeout = () => {
    setCountdown(60);
    const timerInterval = setInterval(() => {
      setCountdown(prevCountdown => {
        if (prevCountdown <= 1) {
          clearInterval(timerInterval);
          setButtonValueResend(false);
          return 0;
        }
        return prevCountdown - 1;
      });
    }, 1000);
  };

  function onChangeOtp(event) {
    if (event.target.value.trim().length === 0) {
      setOtpLengthError(false);
      setOtpIsRequiredError(true);
      setOtp(event.target.value.trim());
    } else {
      setOtpLengthError(false);
      if (/^\d*$/.test(event.target.value.trim())) {
        setOtpIsRequiredError(false);
        if (event.target.value.trim().length <= 6) {
          setOtp(event.target.value.trim());
          setTimeout(() => {
            if (event.target.value.trim().length === 6) {
              buttonRef2?.current.click();
            }
          }, 0)

        } else {
          setOtp(event.target.value.trim().slice(0, 6));
        }
      }
    }
  }

  function onBlurOtp(event) {
    setOtp(otp.trim());
    if (event.target.value.trim().length === 0) {
      setOtpLengthError(false);
      setOtpIsRequiredError(true);
    } else {
      if (event.target.value.trim().length < 6) {
        setOtpIsRequiredError(false);
        setOtpLengthError(true);
      }
    }
  }

  const handleSubmitOtp = async (e) => {
    e.preventDefault();

    if (otp !== "" && otp.trim().length === 6) {
      if (otpIsRequiredError === false && otpLengthError === false) {
        let payload = {
          email: email,
          otp: otp,
          ip: ip
        };

        setButtonValueOtp(true);

        axios
          .post(configData.SERVER_URL + "user/verifyOtp", payload)
          .then((response) => {
            notifysuccess(response.data.message);
            setTimeout(() => {
              let id = jwtDecode(response.data.data.token)._id;
              let role = jwtDecode(response.data.data.token).role;
              let token = response.data.data.token;

              if (role === "admin") {
                axios
                  .get(configData.SERVER_URL + "user/status?_id=" + id)
                  .then((response) => {
                    if (response.data.data.status === "verified") {
                      Cookies.set("token_xapads_ssp", token, { expires: 1 });

                      window.location.replace("/onboarding");
                    } else {
                      Cookies.set("token_xapads_ssp", token, { expires: 1 });

                      window.location.replace("/dashboard");
                    }
                  })
                  .catch((error) => {
                    Cookies.set("token_xapads_ssp", token, { expires: 1 });

                    window.location.replace("/dashboard");
                  });
              } else {
                Cookies.set("token_xapads_ssp", token, { expires: 1 });

                window.location.replace("/dashboard");
              }
            }, 1500);
          })
          .catch((error) => {
            if (error?.response) {
              if (error?.response?.data?.message?.length !== 0) {
                notifyfailure(error.response.data.message);
              }
            } else {
              notifycatch();
            }
            setButtonValueOtp(false);
          });
      }
    } else {
      if (otp === "") {
        setOtpIsRequiredError(true);
      } else {
        if (otp.trim().length !== 6) {
          setOtpLengthError(true);
        }
      }
    }
  };

  if (loading) {
    return (
      <>
        <div className="fullscreen"></div>
      </>
    );
  } else {
    return (
      <>
        <div className={formState === 0 ? "bg_gradient position-relative h_100vh_xs" : "bg_gradient position-relative h_100vh_xs login_p_class"} >
          <div className="text_xs_center" ref={loginMoveRef}><img
            // src={logoBlack}
            src={blackLogo}
            className="helix_logo helix_logo_xs" alt="" /></div>

          <div className="container_box container_box_xs" >
            <Row gutter={16}>
              <Col span={16} className="form_content--section col_xs_12">
                <div className="form_content--intro">
                  <h1 className="heading_carousal">A platform for publishers to</h1>
                  <Swiper
                    direction={"vertical"}  // Set swiper direction to vertical
                    spaceBetween={20}        // No space between slides
                    slidesPerView={1}        // Show one slide at a time
                    pagination={{ clickable: false }} // Disable clickable pagination
                    loop={true}
                    autoplay={{
                      delay: 3000,           // 3 seconds delay between slides
                      disableOnInteraction: false,  // Autoplay will not stop after user interaction
                    }}
                    modules={[Autoplay]}     // Include the Autoplay module
                    className="mySwiper"
                    style={{ height: '100vh' }}  // Adjusting the height of the Swiper
                  >
                    <SwiperSlide>
                      <h2 className="sub_heading_carousal">Access premium demand partners at one place.</h2>
                    </SwiperSlide>
                    <SwiperSlide>
                      <h2 className="sub_heading_carousal">Boost ad revenue seamlessly.</h2>
                    </SwiperSlide>
                    <SwiperSlide>
                      <h2 className="sub_heading_carousal">Tailor ads to visitor preferences.</h2>
                    </SwiperSlide>
                  </Swiper>
                  <picture>
                    <source media="(max-width: 768px)" srcSet={blackLogo} className="banner" />
                    <img src={bannerImage} alt="Helix" className="banner" />
                  </picture>
                  {/* <img
                    src={bannerImage}
                    // src={bannerLogin}
                    alt="Helix" className="banner" /> */}
                  {/* <h1 className="heading">
                    Step into the Future <br />
                    of <span className="primary">Advertising</span> <br />{" "}
                    Innovation!
                  </h1>
                  <p className="text">
                    Discover a New Era in Ad-Tech Excellence.
                  </p> */}
                </div>
              </Col>

              {formState === 0 ?

                (<Col span={8} className='form--section col_xs_12'>
                  <div className="form_content_block">
                    <button onClick={downloadFile} className="mediakit__block">
                      <div className="heading">
                        Grab the Media Kit Now!
                      </div>
                      <span className="text_primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#187B80" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.08301 5.8335L6.99967 8.75016L9.91634 5.8335" stroke="#187B80" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M7 8.75V1.75" stroke="#187B80" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Download
                      </span>
                    </button>
                    <div className="form_content_block--title">
                      <div className="heading">
                        Sign up
                      </div>
                      <p className='text'>Already have an account?
                        {buttonValue ?
                          <span className="primary ms-1">Login</span>
                          :
                          <span onClick={() => { resetRegiterScreen(); setFormState(1) }} className='primary ms-1'
                            style={{ textDecoration: "underline", cursor: "pointer" }}
                          >Login</span>
                        }
                      </p>
                    </div>
                    <div className="form_content_block--group">
                      <label className='form_label'>Name *</label>
                      <Input
                        className={
                          nameIsRequiredError
                            ? "form_control error"
                            : "form_control"
                        }
                        placeholder="Enter your Full Name"
                        prefix={<img src={userIcon} className='input_icon' alt="prefix icon" />}
                        value={name}
                        onBlur={onBlurName}
                        onChange={onChangeName}
                        autocomplete="off"
                      />
                      <span className="error_content h_error">
                        {nameIsRequiredError && (
                          <> This field is required</>
                        )}
                      </span>

                    </div>
                    <div className="form_content_block--group">
                      <label className='form_label'>Organisation Name *</label>
                      <Input
                        className={
                          companyNameIsRequiredError
                            ? "form_control error"
                            : "form_control"
                        }
                        placeholder="Enter Organisation Name"
                        prefix={<img src={organisationIcon} className='input_icon' alt="prefix icon" />}
                        value={companyName}
                        onBlur={onBlurCompanyName}
                        onChange={onChangeCompanyName}
                        autocomplete="off"
                      />

                      <span className="error_content h_error">
                        {companyNameIsRequiredError && (
                          <> This field is required</>
                        )}
                      </span>
                    </div>
                    <div className="form_content_block--group">
                      <label className='form_label'>Email Address *</label>
                      <Input
                        className={
                          (emailRegisterIsRequiredError || emailRegisterUrlError)
                            ? "form_control error"
                            : "form_control"
                        }
                        placeholder="example@gmail.com"
                        prefix={<img src={emailIcon} className='input_icon' alt="prefix icon" />}
                        value={emailRegister}
                        onBlur={onBlurEmailRegister}
                        onChange={onChangeEmailRegister}
                        autocomplete="off"
                      />
                      <span className="error_content h_error">
                        {emailRegisterIsRequiredError && (
                          <> This field is required</>
                        )}
                        {emailRegisterUrlError && (
                          <> Invalid Email Address</>
                        )}
                      </span>


                    </div>
                    <div className="form_content_block--group">
                      <label className='form_label'>Company website *</label>
                      <Input
                        className={
                          (companyWebsiteIsRequiredError || companyWebsiteUrlError)
                            ? "form_control error"
                            : "form_control"
                        }
                        placeholder="Enter Company website"
                        prefix={<img src={websiteIcon} className='input_icon' alt="prefix icon" />}
                        value={companyWebsite}
                        onBlur={onBlurCompanyWebsite}
                        onChange={onChangeCompanyWebsite}
                        autocomplete="off"
                      />
                      <span className="error_content h_error">
                        {companyWebsiteIsRequiredError && (
                          <> This field is required</>
                        )}
                        {companyWebsiteUrlError && (
                          <>Invalid Website Url</>
                        )}
                      </span>

                    </div>
                    <div className="form_content_block--group">
                      <label className='form_label'>IM  *</label>
                      <Space.Compact className={
                        imIsRequiredError
                          ? "form_compact error"
                          : "form_compact"
                      }>
                        <Select
                          className="form_select"
                          value={selectedIm}
                          onChange={onChangeSelectedIm}
                          options={constantData.IM_OPTIONS}
                        />
                        <Input placeholder="Username"
                          className="form_control"
                          value={im}
                          onChange={onChangeIm}
                          onBlur={onBlurIm}
                          autocomplete="off"
                        />
                      </Space.Compact>

                      <span className="error_content h_error">
                        {imIsRequiredError && (
                          <> This field is required</>
                        )}

                      </span>
                    </div>



                    {buttonValue &&
                      <div className="form_content_block--group">
                        <button className="btn_primary btn loader">
                          <span>Sign up</span>
                          <img
                            src={loaderIcon}
                            alt="USP"
                            className="loader_icon"
                          />
                        </button>
                      </div>
                    }

                    {!buttonValue &&
                      <div className="form_content_block--group">
                        <button className='btn_primary btn'
                          ref={buttonRef0}
                          onClick={handleSubmit}
                        >
                          <span>Sign up</span>
                          <img src={loaderIcon} alt='USP' className='loader_icon' />
                        </button>
                      </div>
                    }


                  </div>
                </Col>)

                : formState === 1 ? (
                  <Col span={8} className="form--section col_xs_12">
                    <div className="form_content_block">
                      <div className="form_content_block--title">
                        <div className="heading">Welcome back!</div>
                        <p className="text">
                          Don’t have an account?{" "}
                          {buttonValueEmail ?
                            <span className="primary ms-1"
                            >
                              Sign Up
                            </span>
                            :
                            <span onClick={() => { resetLoginScreen(); setFormState(0) }} className="primary ms-1"
                              style={{ textDecoration: "underline", cursor: "pointer" }}
                            >
                              Sign Up
                            </span>
                          }
                        </p>
                      </div>

                      <div className="form_content_block--group mt-5 mt_0_xs">
                        <label className="form_label">Email Address *</label>
                        <Input
                          className={
                            emailIsRequiredError || emailUrlError
                              ? "form_control error"
                              : "form_control"
                          }
                          placeholder="example@gmail.com"
                          prefix={
                            <img
                              src={emailIcon}
                              className="input_icon"
                              alt="prefix icon"
                            />
                          }
                          value={email}
                          onBlur={onBlurEmail}
                          onChange={onChangeEmail}
                          autocomplete="off"
                        />
                        <span className="error_content h_error">
                          {emailIsRequiredError && (
                            <> This field is required</>
                          )}
                          {emailUrlError && (
                            <> Invalid Email Address</>
                          )}

                        </span>


                      </div>

                      {!buttonValueEmail && (
                        <div className="form_content_block--group">
                          <button
                            className="btn_primary btn"
                            onClick={handleSubmitEmail}
                            ref={buttonRef1}
                          >
                            <span>Submit</span>
                            <img
                              src={loaderIcon}
                              alt="USP"
                              className="loader_icon"
                            />
                          </button>
                        </div>
                      )}

                      {buttonValueEmail && (
                        <div className="form_content_block--group">
                          <button className="btn_primary btn loader">
                            <span>SUBMIT</span>
                            <img
                              src={loaderIcon}
                              alt="USP"
                              className="loader_icon"
                            />
                          </button>
                        </div>
                      )}
                    </div>
                  </Col>
                ) : (
                  <Col span={8} className="form--section col_xs_12">
                    <div className="form_content_block">
                      <div className="form_content_block--title">
                        <div className="heading">OTP Verification</div>
                        <p className="text">
                          We sent a code to{" "}
                          <b className="primary">{email}</b>
                        </p>
                      </div>
                      <div className="form_content_block--group mt-5">
                        <div className="form_label_content">
                          <label className="form_label">OTP *</label>
                          {buttonValueResend ?
                            <span to="/" className="error_label">
                              <span className="dark">Resend OTP in</span> <span className="w_countdown">00:{countdown}</span>
                            </span>
                            :
                            <span style={{ cursor: "pointer" }} className="error_label"
                              onClick={resendOtp}
                            >
                              RESEND
                            </span>
                          }
                        </div>
                        <Input
                          className={
                            otpIsRequiredError || otpLengthError
                              ? "form_control error"
                              : "form_control"
                          }
                          placeholder="0 0 0 0 0 0"
                          prefix={
                            <img
                              src={passwordIcon}
                              className="input_icon"
                              alt="prefix icon"
                            />
                          }
                          value={otp}
                          onChange={onChangeOtp}
                          onBlur={onBlurOtp}
                          autocomplete="off"
                        />
                        <span className="error_content h_error">
                          {otpIsRequiredError && (
                            <> This field is required</>
                          )}
                          {otpLengthError && (
                            <>  OTP should be 6 in characters</>
                          )}

                        </span>


                      </div>

                      {!buttonValueOtp && (
                        <div className="form_content_block--group">
                          <button
                            className="btn_primary btn"
                            ref={buttonRef2}
                            onClick={handleSubmitOtp}
                          >
                            <span>Submit</span>
                            <img
                              src={loaderIcon}
                              alt="USP"
                              className="loader_icon"
                            />
                          </button>
                        </div>
                      )}

                      {buttonValueOtp && (
                        <div className="form_content_block--group">
                          <button className="btn_primary btn loader">
                            <span>SUBMIT</span>
                            <img
                              src={loaderIcon}
                              alt="USP"
                              className="loader_icon"
                            />
                          </button>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
            </Row>
          </div>
        </div >
      </>
    );
  }
};


export default Login;
